import { makeAutoObservable } from "mobx";
import { initialState, REQUIRED_STEP_KEYS, OPTIONAL_STEP_KEYS } from "./state";
import { createMutations } from "./mutations";

const createWelcomeDashboardStore = () => {
  // Deep-clone so initialState stays pristine for resets
  const store = JSON.parse(JSON.stringify(initialState));

  Object.defineProperties(store, {
    requiredCompletedCount: {
      get() {
        return REQUIRED_STEP_KEYS.filter(k => this.stepStatus[k]?.completed).length;
      },
      enumerable: true,
      configurable: true,
    },

    totalRequired: {
      get() {
        return REQUIRED_STEP_KEYS.length;
      },
      enumerable: true,
      configurable: true,
    },

    allRequiredComplete: {
      get() {
        return REQUIRED_STEP_KEYS.every(k => this.stepStatus[k]?.completed);
      },
      enumerable: true,
      configurable: true,
    },

    isOnboardingCallLocked: {
      get() {
        return REQUIRED_STEP_KEYS
          .filter(k => k !== "onboardingCall")
          .some(k => !this.stepStatus[k]?.completed);
      },
      enumerable: true,
      configurable: true,
    },

    // Owner assignment needs ATS users, which only exist once the ATS is connected.
    isOwnerAssignmentLocked: {
      get() {
        return !this.stepStatus.syncDatabase?.completed;
      },
      enumerable: true,
      configurable: true,
    },

    incompleteOptionalSteps: {
      get() {
        return OPTIONAL_STEP_KEYS.filter(k => !this.optionalStepStatus[k]?.completed);
      },
      enumerable: true,
      configurable: true,
    },
  });

  Object.assign(store, createMutations(store));

  makeAutoObservable(store);

  return store;
};

const welcomeDashboardStore = createWelcomeDashboardStore();

export default welcomeDashboardStore;
